/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeQuizEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_QUIZ_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeQuizEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeQuizEnabledSettingParser.decode(input).map(res => new TierFreeQuizEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeQuizEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeQuizEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeQuizEnabledSettingParser.schema();
    }
}
